module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_download.svg?5005ac7f1cd9d48f42381a0499dc6929";